import { useMemo } from 'react';
import storage from '../services/storage';
import {
  getSetterScopedLeadIds,
  filterLeadsForSetter,
  filterListsForSetter,
  buildCountsForLeads,
} from '../utils/setterScope';

/**
 * Kontakte-/Listen-Sicht inkl. Setter-Filter und Zähler.
 * Kern-CRM-State bleibt in CrmApplication; dieses Hook bündelt abgeleitete View-Daten.
 */
export function useCrmContactsScope(leads, lists, currentUser, listAssignVersion = 0) {
  const setterScopedLeadIds = useMemo(
    () => getSetterScopedLeadIds(currentUser, (key) => storage.get(key, []), listAssignVersion),
    [currentUser, listAssignVersion],
  );

  const leadsForContactsView = useMemo(
    () => filterLeadsForSetter(leads, setterScopedLeadIds),
    [leads, setterScopedLeadIds],
  );

  const listsForContactsView = useMemo(
    () => (setterScopedLeadIds ? filterListsForSetter(lists, leadsForContactsView) : lists),
    [lists, leadsForContactsView, setterScopedLeadIds],
  );

  const countsForContactsView = useMemo(
    () => buildCountsForLeads(leadsForContactsView, listsForContactsView),
    [leadsForContactsView, listsForContactsView],
  );

  return {
    setterScopedLeadIds,
    leadsForContactsView,
    listsForContactsView,
    countsForContactsView,
  };
}
